import React, { useState, useEffect, useRef, useContext } from 'react';
import { Form, Button } from 'antd';
import * as Api from '../../services/api';
import Typing from '../Typing/Typing';
import CmpsAnimation from '../CmpsAnimation/CmpsAnimation';
import Timestamp from '../../components/Timestamp/Timestamp'
import { Context } from '../../ChatContext';
import CmpsMsgStatus from '../CmpsMsgStatus/CmpsMsgStatus';
import { ReactComponent as Submit } from '../../assets/images/submit.svg';
import { ReactComponent as Geoloc } from '../../assets/images/geo.svg';

let autoComplete;
// dynamically load JavaScript files in our html with callback when finished
const loadScript = (url, callback) => {
  let script = document.createElement("script"); // create script tag
  script.type = "text/javascript";
  script.setAttribute('id', 'cmps-chat-gmap');

  // when script state is ready and loaded or complete we will call callback
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url; // load by url
  document.getElementsByTagName("head")[0].appendChild(script); // append to head
};
// handle when the script is loaded we will assign autoCompleteRef with google maps place autocomplete
function handleScriptLoad(updateQuery, setAddress, autoCompleteRef, setContext, seatDisableBtnSearch, onAlertAutoComplete) {
  // assign autoComplete with Google maps place one time
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    { types: ["geocode"], componentRestrictions: { country: "it" } }
  );
  autoComplete.setFields(["address_components", "formatted_address", "geometry"]); // specify what properties we will get from API
  // add a listener to handle when the place is selected
  autoComplete.addListener("place_changed", () =>
    handlePlaceSelect(autoCompleteRef, updateQuery, setAddress, setContext, seatDisableBtnSearch, onAlertAutoComplete)
  );
}
async function handlePlaceSelect(autoCompleteRef, updateQuery, setAddress, setContext, seatDisableBtnSearch, onAlertAutoComplete) {
  const addressObject = autoComplete.getPlace();
  if (addressObject.formatted_address !== undefined) {
    const query = addressObject.formatted_address;
    updateQuery(query);
    setContext(prevContext => ({
      ...prevContext,
      coordinates: { lat: addressObject.geometry.location.lat(), lon: addressObject.geometry.location.lng() }
    }));
    setAddress(setMessage(addressObject.address_components));
    cursorPosition(autoCompleteRef.current);
    seatDisableBtnSearch(false);
  } else {
    onAlertAutoComplete();
  }
}

function setMessage(addresses) {
  let address = {};
  let labelAddress = '';
  for (var i = 0; i < addresses.length; i++) {
    var component = addresses[i];
    var addressType = component.types[0];

    switch (addressType) {
      case 'street_number':
        address.streetNumber = component.long_name + ',';
        break;
      case 'route':
        address.route = component.short_name + ',';
        break;
      case 'locality':
        address.locality = component.long_name;
        break;
      case 'postal_code':
        address.postal_code = component.long_name;
        break;
      case 'administrative_area_level_2':
        address.district = component.short_name;
        break;
      default:
    }
  }
  labelAddress += address.route ? address.route + ' ' : '';
  labelAddress += address.streetNumber ? address.streetNumber + ' ' : '';
  labelAddress += address.postal_code ? address.postal_code + ' ' : '';
  labelAddress += address.locality ? address.locality + ' ' : '';
  labelAddress += address.district ? address.district : '';

  return labelAddress;
}

function cursorPosition(end) {
  end.scrollLeft = end.scrollWidth;
}

function Geocode({ onComplete, onShowInput, onAlert, onAlertAutoComplete }) {
  const [typing, setTyping] = useState(true);
  const [search, seatSearch] = useState(false);
  const [disableBtnSearch, seatDisableBtnSearch] = useState(true)
  const [address, setAddress] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);
  const [msg, setMsg] = useState(false);
  const [context, setContext] = useContext(Context);

  const [query, setQuery] = useState("");
  const autoCompleteRef = useRef(null);

  const setAddressByGeocode = (params) => {
    // Api.getGeocodeAddress(params).then(function (response) {
    //   setAddress(setMessage(response.data.results[0].address_components));
    //   setQuery(setMessage(response.data.results[0].address_components));
    //   cursorPosition(autoCompleteRef.current);
    //   setBtnLoading(false);
    //   seatSearch(false);
    //   seatDisableBtnSearch(false);
    // })
    // .catch(function (error) {
    //   console.log(error);
    // });
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: params }, (results, status) => {
      if (status === "OK") {
        setAddress(setMessage(results[0].address_components));
        setQuery(setMessage(results[0].address_components));
        cursorPosition(autoCompleteRef.current);
        setBtnLoading(false);
        seatSearch(false);
        seatDisableBtnSearch(false);
      } else {
        console.error("[compass-chat] Geocoder failed due to: " + status);
      }
    });

  }
  const getCurrentGeocode = (e) => {
    setBtnLoading(true);
    seatSearch(true);
    const optionsGeocode = {
      enableHighAccuracy: true,
      timeout: 8000,
      maximumAge: 0
    };
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        // Success response
        const crd = pos.coords;
        const apiKey = process.env.REACT_APP_API_KEY;

        // const params = {
        //   latlng: crd.latitude+','+crd.longitude,
        //   key: apiKey,
        //   sensor: false
        // }
        const params = {
          lat: crd.latitude,
          lng: crd.longitude
        }
        setAddressByGeocode(params);

        setContext(prevContext => ({
          ...prevContext,
          coordinates: { lat: crd.latitude, lon: crd.longitude }
        }));
      },
      function (err) {
        // Error response
        console.warn(`ERROR(${err.code}): ${err.message}`);
        if (err.code == 3) {
          setBtnLoading(false);
          seatSearch(false);
          seatDisableBtnSearch(false);
          onAlert();
        }
      },
      optionsGeocode
    );
  }

  const onInputChange = (event) => {
    seatDisableBtnSearch(true);
    setQuery(event.target.value)
  }
  const onInputFocus = (event) => {
    seatDisableBtnSearch(true);
  }

  const send = () => {
    setMsg(address);
    onComplete('step2');
  }

  useEffect(() => {
    onShowInput(false);
    if (!document.getElementById("cmps-chat-gmap")) {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_API_KEY}&libraries=places`,
        () => handleScriptLoad(setQuery, setAddress, autoCompleteRef, setContext, seatDisableBtnSearch, onAlertAutoComplete)
      );
    } else {
      handleScriptLoad(setQuery, setAddress, autoCompleteRef, setContext, seatDisableBtnSearch, onAlertAutoComplete)
    }
    const timer = setTimeout(() => {
      setTyping(false);
      onShowInput(true);
    }, 1700);
    return () => clearTimeout(timer);

  }, []);


  return (
    <section id="geocode">
      {typing && <Typing wait={100} />}
      {!typing && (
        <div className="messages messages--receiver">
          <div className="message">
            <CmpsAnimation wait={300}>
              <span className="bubble">Dove vuoi fissare l’appuntamento?</span>
            </CmpsAnimation>
            <CmpsAnimation wait={600} last={true}>
              <span className="bubble">Digita il tuo indirizzo e città oppure<br /> utilizza la tua posizione attuale</span>
            </CmpsAnimation>
            <CmpsAnimation wait={900}>
              {!address && (
                <Button className={['cmps_btn', 'cmps_btn__geoloc']} loading={btnLoading} onClick={getCurrentGeocode}>
                  <Geoloc className="icon-cmps-geo" width="20" height="20" />
                  Utilizza la tua posizione attuale
                </Button>
              )}
              <div className="info">
                <span className="time"><Timestamp /></span>
              </div>
            </CmpsAnimation>
          </div>
        </div>
      )}
      {msg && (
        <div className="messages messages--sender">
          <CmpsAnimation wait={300}>
            <div className="message">
              <span className="bubble">{address}</span>
            </div>
            <div className="info">
              <span className="time"><Timestamp /></span>
              <CmpsMsgStatus />
            </div>
          </CmpsAnimation>
        </div>
      )}
      <Form.Item className={`cmps_input ${!typing && !msg ? 'show' : ''}`} name="posizione">
        <div className="ant-form-item-control-input">
          <div className="ant-form-item-control-input-content">
            <input
              placeholder="Scrivi qui"
              ref={autoCompleteRef}
              onChange={onInputChange}
              onFocus={onInputFocus}
              value={query}
              className="ant-input"
              disabled={search}
            />
            <Button className={['cmps_btn__send']} onClick={send} disabled={disableBtnSearch}>
              <Submit className="icon-cmps-submit" />
            </Button>
          </div>
        </div>
      </Form.Item>
    </section>
  );
}

export default Geocode;
